import { createZodDto } from "nestjs-zod/dto";

import { userSchema } from "./user";

export const updateUserSchema = userSchema.partial().pick({
  name: true,
  locale: true,
  email: true,
  picture: true,
  isActivated: true,
});

export class UpdateUserDto extends createZodDto(updateUserSchema) {}
